module.exports = __webpack_public_path__ + "static/img/CBF.af6cf67f.png";